import { Component, computed, effect, inject, input, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AlerteComponent } from '@shared/components/alerte/alerte.component';
import { BrnSelectImports } from '@spartan-ng/brain/select';
import { HlmCheckboxImports } from '@spartan-ng/helm/checkbox';
import { HlmFieldImports } from '@spartan-ng/helm/field';
import { HlmInputImports } from '@spartan-ng/helm/input';
import { HlmLabelImports } from '@spartan-ng/helm/label';
import { HlmRadioGroupImports } from '@spartan-ng/helm/radio-group';
import { HlmSelectImports } from '@spartan-ng/helm/select';
import { HlmSwitchImports } from '@spartan-ng/helm/switch';

import { LabelRequiredDirective } from '../../../../shared/directives/label-required.directive';
import { ÉTAT_VALIDATION_ÉTAPE } from '../../../models/état-validation-étape.enum';
import { EtapeStore } from '../../../parcours-etape/store/etape.store';
import { GroupeÉtapesÀLaCarteStore } from '../../../store/groupe-étapes-à-la-carte/groupe-étapes-à-la-carte.store';
import { DetailGeneralFormGroup } from '../detail-form-groups.types';
import { EtapeDetailFormService } from '../étape-detail-form.service';

@Component({
  selector: 'app-detail-general',
  imports: [
    ReactiveFormsModule,
    HlmInputImports,
    HlmFieldImports,
    HlmRadioGroupImports,
    HlmSwitchImports,
    LabelRequiredDirective,
    HlmCheckboxImports,
    HlmSelectImports,
    BrnSelectImports,
    AlerteComponent,
    HlmLabelImports,
  ],
  templateUrl: './detail-general.component.html',
})
export class DetailGeneralComponent {
  readonly #detailService = inject(EtapeDetailFormService);
  readonly #groupeStore = inject(GroupeÉtapesÀLaCarteStore);
  readonly #etapeStore = inject(EtapeStore);

  readonly form = input.required<DetailGeneralFormGroup>();

  readonly groupes = this.#groupeStore.entities;

  readonly estValidee = computed(
    () => this.#etapeStore.selectedEntity()?.etatValidation === ÉTAT_VALIDATION_ÉTAPE.VALIDEE,
  );

  isChecked(typeContrat?: string) {
    let isChecked = false;
    if (this.typesContrat.value) {
      isChecked = typeContrat ? this.typesContrat.value.includes(typeContrat) : this.autreType.value !== null;
    }
    return isChecked;
  }

  changed($event: boolean, value: string) {
    if (!$event && value === 'autre') {
      this.autreType.setValue('');
      return;
    }

    if ($event && value !== 'autre') {
      this.typesContrat.setValue([...this.typesContrat.value, value]);
    } else if (this.typesContrat.value.includes(value)) {
      const typesContrat = this.typesContrat.value;
      const idxToDelete = typesContrat.findIndex((x) => x === value);
      typesContrat.splice(idxToDelete, 1);
      this.typesContrat.setValue(typesContrat);
    }
  }

  handleEstALaCarteChange() {
    const nouveauEstALaCarte: boolean = !this.estALaCarte.value;
    this.estALaCarte.setValue(nouveauEstALaCarte, { emitEvent: false });

    if (!nouveauEstALaCarte) {
      this.groupesFc.setValue([]);
    }
  }

  get nom() {
    return this.#detailService.nom;
  }

  get code() {
    return this.#detailService.codeEtape;
  }

  get typesContrat() {
    return this.#detailService.typesContrat;
  }

  get autreType() {
    return this.#detailService.autreType;
  }

  get estALaCarte() {
    return this.#detailService.estALaCarte;
  }

  get groupesFc() {
    return this.#detailService.groupes;
  }
}
